import { Typography, useMediaQuery, useTheme } from '@mui/material'
import React from 'react'

interface SmallPrintTypographyProps {
  printValue: string
  displayOnDesktop: boolean
}

const SmallPrintTypography: React.FC<SmallPrintTypographyProps> = ({ printValue, displayOnDesktop }) => {
  const theme = useTheme()
  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'))

  if (isDesktop && !displayOnDesktop) {
    return null
  }

  return (
    <Typography
      sx={{ marginTop: '0px!important', paddingLeft: '3px' }}
      noWrap
      align='center'
      color={theme.palette.grey[500]}
      variant='caption'
      display='block'
      gutterBottom
    >
      <span>{printValue}</span>
    </Typography>
  )
}


export default SmallPrintTypography
